import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import clsx from 'clsx';
import { useAuthStore } from '../store/authStore';
import { useCheckAuth } from '../api/hooks/useCheckAuth';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { ProfileTab } from '../components/Profile/ProfileTab';

export const ProfilePage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuthStore();
  const { isLoading, error } = useCheckAuth();

  // Show loading state
  if (isLoading && !currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  // Show error state
  if (error && !currentUser) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className={clsx(
            'flex items-center gap-2 mb-6 px-3 py-2 rounded-lg',
            'text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-950',
            'transition-colors duration-150'
          )}
        >
          <ArrowLeft size={20} />
          Back
        </button>
        <div className="rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-950 p-4">
          <p className="text-red-600 dark:text-red-400">
            Failed to load profile information. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return null;
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className={clsx(
          'flex items-center gap-2 mb-6 px-3 py-2 rounded-lg',
          'text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-950',
          'transition-colors duration-150'
        )}
      >
        <ArrowLeft size={20} />
        Back
      </button>

      {/* Header */}
      <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-8">
        Profile
      </h1>

      <ProfileTab />
    </div>
  );
};
